<template>
  <div>
    <HelperText v-if="helperText" :id="id" :text="helperText" :status="status" class="mb-24" />
    <fieldset class="toggle-token-group grid-cols-2" :class="gridClasses" tabindex="-1">
      <legend class="sr-only">{{ legend }}</legend>
      <ToggleToken
        v-for="(token, i) in tokens"
        :key="`${id}-${i}`"
        v-model="token.value"
        :checkboxId="`${id}-${i}`"
        :status="status"
        :text="token.text"
        :icon="token.icon"
        :iconHeight="token.iconHeight"
        :iconWidth="token.iconWidth"
        :iconType="token.iconType"
        :ariaLabel="token.ariaLabel"
        @update:modelValue="updateValue"
      >
        <template v-if="token.formattedText || token.pill" #formattedText>
          <Pill v-if="token.pill" :color="token.pill.color">{{ token.pill.text }}</Pill>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-if="token.formattedText" v-html="token.formattedText" />
        </template>
      </ToggleToken>
    </fieldset>
  </div>
</template>

<script lang="ts">
import ToggleToken from './ToggleToken.vue';
import helperStatus from '../../helpers/status';
import HelperText from '../helper_text/HelperText.vue';
import Pill from '../pill/Pill.vue';

export default {
  name: 'ToggleTokenGroup',
  components: { ToggleToken, HelperText, Pill },
  props: {
    maxColumns: {
      type: Number,
      default: 3,
    },
    tokens: {
      type: Array,
      required: true,
    },
    helperText: {
      type: String || null,
      required: false,
      default: null,
    },
    status: {
      type: Number as () => helperStatus,
      default: helperStatus.Neutral,
    },
    customId: {
      type: String || null,
      default: null,
    },
    legend: {
      type: String || null,
      required: false,
      default: null,
    },
  },
  computed: {
    id(): String {
      return this.customId || 'toggle-token-group';
    },
    gridClasses(): String {
      return `lg:grid-cols-${this.maxColumns}`;
    },
  },
  methods: {
    updateValue() {
      this.$emit('update:modelValue', this.tokens);
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-token-group {
  display: grid;
  grid-auto-rows: 1fr;
  gap: 1rem;
  outline: none;
}
</style>
